import { InjectionToken } from '@angular/core';

export const USE_SVG_ICONS_DEFAULT_NAVIGATION = new InjectionToken(
  'use svg icons default navigation',
  {
    factory: () => true,
    providedIn: 'root',
  },
);

